import React from "react"
import Image from "next/image"
import { useState } from "react"

export default function CustomImage(props) {
    const { src, ...rest } = props
    const imageSources = getImageSources(src)

    const [currentIndex, setCurrentIndex] = useState(0)

    return (
        <Image
            {...rest}
            key={imageSources[currentIndex]}
            src={imageSources[currentIndex]}
            onError={() => {
                console.log("Image failed", imageSources[currentIndex])
                if (currentIndex < imageSources.length - 1) {
                    setCurrentIndex((prev) => prev + 1)
                }
            }}
        />
    )
}

const PLACEHOLDER =
    "https://webb-jenkins-static-164679926.imgix.net/placeholder.svg"

const DOMAIN_MAP = {
    "webb-jenkins-236939759.imgix.net": "webbjenkins.imgix.net",
    "webb-jenkins-static-164679926.imgix.net": "webbjenkinsstatic.imgix.net",
}

function getImageSources(src) {
    const url = new URL(src)

    return [
        src,
        `${url.protocol}//${DOMAIN_MAP[url.hostname]}${url.pathname}${url.search}`,
        PLACEHOLDER,
    ].filter(Boolean)
}
